import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV } from "./Header";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 px-5 py-14 md:px-10" data-testid="site-footer">
      <div className="mx-auto flex max-w-[1440px] flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <div>
          <Logo />
          <p className="mt-5 max-w-sm text-sm text-[var(--muted)]">{t("footer.blurb")}</p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm">
          {NAV.map(([to, label, id]) => <Link key={to} to={to} className="nav-link" data-testid={id.replace("nav-link", "footer-link")}>{t(label)}</Link>)}
        </div>
        <p className="mono text-[11px] text-[var(--muted)]">© {new Date().getFullYear()} MUTONI® · {t("footer.tag")}</p>
      </div>
    </footer>
  );
};
